import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { _ } from '_locales';
import { colors as fixedColors } from '_styles';

const parentWidth = document
  .getElementById('rcroot')
  .getBoundingClientRect().width;

const Tabs = ({ colors, navigate, webappConfig }) => {
  const { pathname } = useLocation();
  const { main_color } = colors;
  const {
    has_wgw = false,
    wgw_title = '',
    has_calendar = false,
    calendar_title = false,
    has_dz = false,
    has_bulk_pickup = false
  } = webappConfig;

  const isWgwPage = /wgw/gi.test(pathname);
  const isCalendarPage = /cal|zone-setup/gi.test(pathname);
  const isEducationPage = /education/gi.test(pathname);
  const isHelpPage = /help/gi.test(pathname);
  const isMaterialListPage = /material-list/gi.test(pathname);
  const isBulkPickupPage = /bulk-pickup/gi.test(pathname);

  const activeTabsData = [
    {
      route: '/cal',
      label: 'general.your_pickup_schedule',
      isActive: has_calendar,
      isSelected: isCalendarPage,
      title: calendar_title,
      ref: useRef(null),
    },
    {
      route: '/wgw',
      label: 'homePage.what_goes_where',
      isActive: has_wgw,
      isSelected: isWgwPage,
      title: wgw_title,
      ref: useRef(null),
    },
    {
      route: '/education',
      label: 'education.discovery_zone',
      isActive: has_dz,
      isSelected: isEducationPage,
      title: false,
      ref: useRef(null),
    },
    {
      route: '/bulk-pickup',
      label: 'bulkPickup.title',
      isActive: has_bulk_pickup,
      isSelected: isBulkPickupPage,
      title: false,
      ref: useRef(null),
    },
  ].filter((item) => item.isActive);

  const onKeyPressHandler = (e, route) => {
    const tabs = [];
    if (has_calendar) tabs.push('/cal');
    if (has_wgw) tabs.push('/wgw');
    if (has_dz) tabs.push('/education');
    if (has_bulk_pickup) tabs.push('/bulk-pickup');

    if (e.key === 'ArrowLeft') {
      const previousTabIndex = tabs.indexOf(route) === 0
        ? tabs.length - 1 : tabs.indexOf(route) - 1;
      activeTabsData[previousTabIndex].ref.current.focus();
      navigate(tabs[previousTabIndex]);
    }
    if (e.key === 'ArrowRight') {
      const nextTabIndex = tabs.indexOf(route) === tabs.length - 1 ? 0 : tabs.indexOf(route) + 1;
      activeTabsData[nextTabIndex].ref.current.focus();
      navigate(tabs[nextTabIndex]);
    }
  };

  return (
    <TabsContainer
      primaryColor={main_color}
      role="tablist"
      aria-label="Navigation tabs"
    >
      {activeTabsData.map((item) => (
        <li role="presentation">
          <Tab
            onClick={() => navigate(item.route)}
            onKeyDown={(e) => onKeyPressHandler(e, item.route)}
            className={item.isSelected ? 'active' : ''}
            role="tab"
            aria-selected={item.isSelected}
            aria-label={_(item.label)}
            tabIndex={item.isSelected ? 0 : -1}
            ref={item.ref}
          >
            <p>{item.title.length ? item.title : _(item.label)}</p>
          </Tab>
        </li>
      ))}
    </TabsContainer>
  );
};
const mapStateToProps = (store) => ({
  colors: store.config.templateColour
    ? JSON.parse(store.config.templateColour)
    : {},
  webappConfig: store.config.webappConfig,
});

export default connect(mapStateToProps, null)(Tabs);

const Tab = styled.button`
  width: 100% !important;
  height: 100% !important;
  background-color: #f3f7fc;
  padding: 10px 25px !important;

  text-align: center;

  border: none;

  border-radius: 8px 8px 0 0;
  font-size: 15px !important;
  font-weight: 300 !important;
  cursor: pointer;
  margin-bottom: 0 !important;
  color: #000 !important;

  &:hover {
    transition: 0.2s all;
    box-shadow: inset rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }
  &:last-child {
    margin-right: 0 !important;
  }
  &.active {
    background-color: #fff;
    font-weight: 500 !important;
  }

  ${parentWidth < 591
  && css`
    padding: 10px !important;
  `}

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: 0;
    padding: 0;
  }
`;

const TabsContainer = styled.ul`
  display: flex;
  list-style: none;
  padding: 0 !important;
  justify-content: space-between;
  margin: 0 !important;
  width: 100%;
  position: relative;
  list-style-type: none !important;
  border-right: 1px solid
    ${({ primaryColor }) => (primaryColor ? `#${primaryColor}` : fixedColors.RC_ROYAL)};
  li {
    flex: 1;
    margin-right: 3px !important;

    &:last-child {
      margin-right: 0 !important;
    }
  }
`;
